/**
 * Style constants for TwoFAQRCode component
 * Extracts inline styles into reusable constants
 */

import { CSSProperties } from "react";

export const LAYOUT_STYLES = {
  twoColumnContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "86%",
    marginTop: "0px",
    marginBottom: "0px",
  } as CSSProperties,

  leftColumn: {
    width: "50%",
    marginRight: 140,
  } as CSSProperties,

  rightColumn: {
    width: "50%",
  } as CSSProperties,

  centeredContent: {
    display: "flex",
    justifyContent: "center",
    marginTop: "5px",
    marginBottom: "5px",
  } as CSSProperties,

  centeredContentWithMargin: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "5px",
    textAlign: "center",
  } as CSSProperties,

  centeredBlock: {
    display: "block",
    marginTop: "20px",
    marginBottom: "20px",
    textAlign: "center",
  } as CSSProperties,

  centeredButtonContainer: {
    display: "flex",
    marginTop: "30px",
    marginBottom: "10px",
    justifyContent: "center",
  } as CSSProperties,
} as const;

export const MODAL_STYLES = {
  otpErrorContainer: {
    textAlign: "center",
    fontSize: "10px",
    marginBottom: "20px",
  } as CSSProperties,

  qrCodeSeparator: {
    marginTop: "50px",
    marginLeft: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } as CSSProperties,
} as const;

export const SVG_CONSTANTS = {
  dashedLine: {
    width: 180,
    height: 20,
    strokeWidth: 2,
    dashArray: "20,10",
    stroke: "black",
  },
} as const;
